import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "flowbite";
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";

const PaymentReference = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");
    const [references, setReferences] = useState([]);

    const [reference, setReference] = useState('');
    const [paymentGateway, setPaymentGateway] = useState('');
    const [userType, setUserType] = useState("");

    const navigate = useNavigate();

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    const [filters, setFilters] = useState({
        page: 1,
        limit: 10,
    });
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 0,
    });


    useEffect(() => {
        const getReferences = async () => {
            const queryParams = Object.entries(filters)
                .filter(([_, value]) => value) // Only include parameters with non-empty values
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join("&");
            try {
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/references/get-payment-reference?${queryParams}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                if (res.data.success) {
                    setReferences(res.data.references);
                    setPagination({
                        totalRecords: res.data.pagination.totalRecords,
                        currentPage: res.data.pagination.currentPage,
                        totalPages: res.data.pagination.totalPages,
                        limit: res.data.pagination.limit,
                    });
                } else {
                    setReferences([]);
                }


            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                    }
                } else {
                    // Handle other errors
                    toast.error("No Tickets Found!");
                }
            }
        }
        getReferences();
        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'references'
            ));
        }

    }, [filters]);


    useEffect(() => {
        // Initialize the modal on component mount
        const modalElement = document.getElementById("edit-modal");
        if (modalElement) {
            const modal = new Modal(modalElement);
            modal.hide(); // Ensure the modal is initially hidden
        }

    }, []);


    // update single admin data
    const handlePaymentUpdate = async (e) => {
        e.preventDefault();

        const postData = {
            "reference": reference,
            "paymentGateway": paymentGateway,
            "userType": userType,
        };

        try {

            const res = await axios.post(process.env.REACT_APP_API_URL + "api/references/update-reference/", postData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "auth_token": `${auth_token}`,
                },
            });

            if (res.status === 200) {
                toast.success("Payment Updated Successfully!");
            }

        } catch (err) {
            if (err.response?.status === 400) {
                // Handle invalid token error
                if (err.response.data === "invalid token") {
                    navigate("/login"); // Redirect to login page
                } else {
                    toast.error(err.response.data.message); // Show other 400 errors
                }
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred.");
            }
        }

    };

    const handlePageChange = (newPage) => {
        setFilters((prev) => ({ ...prev, page: newPage }));
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString.replace(" ", "T")); // Replace space with T for compatibility
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const time = date.toLocaleTimeString('en-US', { hour12: false });
        return `${formattedDate} ${time}`;
    };

    return (
        <div className="bg-gray-100">
            <div className="py-20 p-4 sm:ml-64">

                <div className="md:flex justify-between py-5">

                    {
                        permissionModule.canCreate &&
                        <button type="button"
                            onClick={() => {
                                const createElement = document.getElementById("edit-modal");
                                if (createElement) {
                                    const create_modal = new Modal(createElement);
                                    create_modal.show();
                                }
                            }}
                            className="flex text-white bg-black rounded-full px-5 py-2 my-5">Update Payment</button>
                    }
                </div>

                <div className="w-full  p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">

                    <div className="flex justify-start">
                        <div className="flex flex-col text-left">
                            <h1 className="text-xl text-black font-bold">Payment References</h1>

                        </div>

                    </div>

                    <div className="relative overflow-x-auto custom-scrollbar sm:rounded-lg mt-5">

                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Reference Id</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Name</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Email</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Amount</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Payment Gateway</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Date/Time</th>

                                </tr>
                            </thead>
                            <tbody>
                                {references.length > 0 ? (
                                    permissionModule.canRead ? references.map((ref) => (
                                        <tr key={ref.id} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{ref.reference}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{ref.User ? ref.User.name : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{ref.User ? ref.User.email : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{ref.amount ? ref.amount : "0"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words capitalize">{ref.paymentGateway ? ref.paymentGateway : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(ref.createdAt)}</td>

                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 whitespace-normal break-words">No Tickets Found.</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>


                        {/* Pagination */}
                        <div className="flex justify-center my-4">
                            <button
                                onClick={() => handlePageChange(filters.page - 1)}
                                disabled={filters.page === 1}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 mx-1 font-medium">
                                Page {pagination.currentPage} of {pagination.totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(filters.page + 1)}
                                disabled={filters.page === pagination.totalPages}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {/* edit modal */}
            <div
                id="edit-modal"
                tabIndex={-1}
                className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
            >
                <div className="relative p-4 w-full max-w-4xl max-h-[60%]">
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        <button
                            type="button"
                            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={() => {
                                const modalElement = document.getElementById("edit-modal");
                                if (modalElement) {
                                    const modal = new Modal(modalElement);
                                    modal.hide();
                                }
                            }}
                        >
                            <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                />
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-4  text-center">
                            <div className=" p-6 bg-white shadow rounded-lg">
                                <h2 className="text-2xl font-bold text-center mb-6">Payment Update</h2>
                                <form onSubmit={handlePaymentUpdate}>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-left">

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Reference ID</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <input
                                                type="text"
                                                className="w-full mb-1 p-2 border border-gray-300 rounded"
                                                placeholder=""
                                                value={reference}
                                                onChange={(e) => setReference(e.target.value)}
                                            />
                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">Payment Gateway</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <select
                                                id="payment"
                                                className="w-full p-2 border border-gray-300 rounded"
                                                value={paymentGateway}
                                                onChange={(e) => setPaymentGateway(e.target.value)}
                                                required
                                            >
                                                <option value="" disabled>-- SELECT PAYMENT GATEWAY --</option>
                                                <option value="paystack">Paystack</option>
                                                <option value="flutterwave">Flutterwave</option>
                                                <option value="fincra">Fincra</option>
                                            </select>

                                        </div>

                                        <div className="md:col-span-1">
                                            <label className="block mb-1 font-medium">User Type</label>
                                        </div>
                                        <div className="md:col-span-2">
                                            <select
                                                id="payment"
                                                className="w-full p-2 border border-gray-300 rounded"
                                                value={userType}
                                                onChange={(e) => setUserType(e.target.value)}
                                                required
                                            >
                                                <option value="" disabled>-- SELECT USER TYPE --</option>
                                                <option value="player">Player</option>
                                                <option value="kiosk">Kiosk</option>
                                            </select>

                                        </div>

                                    </div>

                                    <div className="mt-5 flex justify-end">



                                        <div>

                                            <button
                                                type="submit"
                                                className="text-white bg-black rounded-full text-sm inline-flex items-center px-5 py-2.5 text-center"
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => {
                                                    const modalElement = document.getElementById("edit-modal");
                                                    if (modalElement) {
                                                        const modal = new Modal(modalElement);
                                                        modal.hide();
                                                    }
                                                }}
                                                type="button"
                                                className="py-2.5 px-5 ms-3 text-sm font-medium text-black focus:outline-none bg-white rounded-full border border-black hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>


                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default PaymentReference;